import CookieBanner from './CookieBanner'
export { default as useCookieBannerAutoReject } from './useCookieBannerAutoReject'
export type * from './CookieBanner'
export default CookieBanner
